/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarioSetVisibilitaDto } from '../../models/calendario-set-visibilita-dto';

export interface ApiCalendarioCalendarioSetVisibilitaListPost$Params {
    /**
     * Corpo per cui caricare la configurazione
     */
    corpoId: number;

    /**
     * application/json
     */
    body: CalendarioSetVisibilitaDto;
}

export function apiCalendarioCalendarioSetVisibilitaListPost(
    http: HttpClient,
    rootUrl: string,
    params: ApiCalendarioCalendarioSetVisibilitaListPost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(rootUrl, apiCalendarioCalendarioSetVisibilitaListPost.PATH, 'post');
    if (params) {
        rb.query('corpoId', params.corpoId, {});
        rb.body(params.body, 'application/json');
    }

    return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        }),
    );
}

apiCalendarioCalendarioSetVisibilitaListPost.PATH = '/api/calendario/calendario-set-visibilita-list';
